import Vue2Preview from './preview.vue'

export default {
  install(Vue, options) {
    Vue.mixin({
      components: {
        'vue-preview': Vue2Preview
      }
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue2-preview@1.0.5@vue2-preview/src/plugins/preview/index.js
// module id = LMgD
// module chunks = 80